import { render, staticRenderFns } from "./DeviceInspection.vue?vue&type=template&id=88ab07da&scoped=true"
import script from "./DeviceInspection.vue?vue&type=script&lang=js"
export * from "./DeviceInspection.vue?vue&type=script&lang=js"
import style0 from "./DeviceInspection.vue?vue&type=style&index=0&id=88ab07da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ab07da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ab07da')) {
      api.createRecord('88ab07da', component.options)
    } else {
      api.reload('88ab07da', component.options)
    }
    module.hot.accept("./DeviceInspection.vue?vue&type=template&id=88ab07da&scoped=true", function () {
      api.rerender('88ab07da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAccounts/DeviceInspection.vue"
export default component.exports